function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLmsEditSquare = function SvgLmsEditSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.951 22a1.88 1.88 0 0 1-1.378-.573A1.874 1.874 0 0 1 2 20.051V6.41c0-.536.19-.995.573-1.377A1.882 1.882 0 0 1 3.95 4.46h8.708l-1.952 1.95H3.951V20.05H17.61V13.28l1.951-1.949v8.721c0 .536-.19.995-.573 1.376A1.88 1.88 0 0 1 17.61 22H3.95ZM14.854 5.02l1.39 1.365-6.44 6.431v1.389h1.367l6.463-6.456 1.39 1.364L12 16.153H7.854v-4.14l7-6.992Zm4.17 4.093-4.17-4.092 2.439-2.436c.39-.39.858-.585 1.403-.585.544 0 1.003.195 1.377.585l1.366 1.388c.374.374.561.828.561 1.364 0 .536-.187.991-.561 1.365l-2.415 2.411Z",
    fill: "currentColor"
  }));
};
export default SvgLmsEditSquare;